const breakpoints = [
  '23rem',
  '38rem',
  '56rem',
  '60rem',
  '77rem', // 1232 if rem is standard. everything below is XL
  '85rem',
  '100rem',
  '112rem',
  '128rem',
  '136rem',
]

export default breakpoints
